/* Painel de busca com resultados enquanto o cliente digita.

   Antes o ícone era um link para /search e qualquer clique tirava a pessoa da
   página. Agora abre um painel, e só se navega ao escolher um produto ou pedir
   a lista completa.

   O ganho de alcance vem do parâmetro fields: sem ele a busca preditiva olha
   só título, tipo, variante e marca — com 'tag,body' ela passa a considerar as
   descrições, o que faz "cacheado" achar a linha Wavy e "1L" achar os litros. */
(function () {
  'use strict';

  var painel = document.querySelector('[data-search-overlay]');
  var abrir = document.querySelector('[data-search-toggle]');
  if (!painel || !abrir) return;

  var input = painel.querySelector('[data-search-input]');
  var caixa = painel.querySelector('[data-search-results]');
  var limpar = painel.querySelector('[data-search-clear]');
  var form = painel.querySelector('form');

  var CAMPOS = 'title,product_type,variants.title,vendor,tag,body';
  var LIMITE = 8;
  var MIN = 2;

  /* Os produtos de brinde a R$ 0,00 precisam ficar publicados para o tema
     conseguir adicioná-los ao carrinho, então o índice do Shopify os acha:
     buscar "hit" devolvia "Leave-In Hit 10x1 — Brinde" a R$ 0,00 ao lado do
     que custa 119,90.

     Aqui o filtro entra na CONSULTA, e não no resultado: assim a vaga é
     reocupada por um produto real em vez de abrir buraco na lista de 8.

     MEDIDO: isto vale só para o suggest.json. Na página /search o mesmo
     `-tag:brinde` é OR, não exclusão — "hit -tag:brinde" devolve 76 produtos,
     e pôr `AND` não muda. Por isso o link "Ver todos os resultados" leva o
     termo LIMPO, e quem filtra a página é o `unless` do main-search.liquid. */
  var FILTRO = '-tag:brinde';
  function comFiltro(t) {
    return t.indexOf(FILTRO) > -1 ? t : t + ' ' + FILTRO;
  }

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function fmt(v) { return money.format(parseFloat(v)); }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* A API devolve a imagem original (1000px) e a miniatura tem 48px — sem
     redimensionar, cada busca baixaria alguns MB à toa. */
  function miniatura(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=96';
  }

  var termos = (painel.getAttribute('data-termos') || '')
    .split(',').map(function (t) { return t.trim(); }).filter(Boolean);

  function sugestoes() {
    if (!termos.length) return '';
    return '<p class="lof-busca__titulo">Buscas populares</p>' +
      '<div class="lof-busca__chips">' +
      termos.map(function (t) {
        return '<button type="button" class="lof-busca__chip" data-search-term="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('') +
      '</div>';
  }

  function linha(p) {
    var src = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    var img = src
      ? '<img src="' + esc(miniatura(src)) + '" alt="" width="48" height="48" loading="lazy">'
      : '<span class="lof-busca__semfoto"></span>';
    var preco = p.price ? fmt(p.price) : '';
    return '<a href="' + esc(p.url) + '" class="lof-busca__item">' +
             '<span class="lof-busca__thumb">' + img + '</span>' +
             '<span class="lof-busca__info">' +
               '<span class="lof-busca__nome">' + esc(p.title) + '</span>' +
               '<span class="lof-busca__preco">' + preco + '</span>' +
             '</span>' +
           '</a>';
  }

  function pintar(termo, produtos) {
    if (!produtos.length) {
      caixa.innerHTML = '<p class="lof-busca__vazio">Nada encontrado para <strong>' + esc(termo) + '</strong>.</p>' + sugestoes();
      return;
    }
    var url = '/search?q=' + encodeURIComponent(termo) + '&type=product&options%5Bprefix%5D=last';
    caixa.innerHTML =
      '<div class="lof-busca__lista">' + produtos.map(linha).join('') + '</div>' +
      '<a href="' + url + '" class="lof-busca__todos">Ver todos os resultados para “' + esc(termo) + '”</a>';
  }

  var pedido = 0;

  function buscar(termo) {
    var meu = ++pedido;
    caixa.innerHTML = '<p class="lof-busca__carregando">Buscando…</p>';

    /* `termo` segue limpo para o que aparece na tela; só a consulta leva o filtro. */
    fetch('/search/suggest.json?q=' + encodeURIComponent(comFiltro(termo)) +
          '&resources[type]=product&resources[limit]=' + LIMITE +
          '&resources[options][fields]=' + encodeURIComponent(CAMPOS),
          { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        /* Descarta resposta antiga: digitar rápido gera respostas fora de ordem. */
        if (meu !== pedido) return;
        pintar(termo, (d.resources && d.resources.results && d.resources.results.products) || []);
      })
      .catch(function () {
        if (meu !== pedido) return;
        caixa.innerHTML = '<p class="lof-busca__vazio">Não foi possível buscar agora. Tente de novo.</p>';
      });
  }

  var timer;
  function aoDigitar() {
    var termo = input.value.trim();
    limpar.classList.toggle('hidden', !termo);
    clearTimeout(timer);

    if (termo.length < MIN) { pedido++; caixa.innerHTML = sugestoes(); return; }
    timer = setTimeout(function () { buscar(termo); }, 250);
  }

  function abrirPainel() {
    painel.classList.remove('hidden');
    painel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!input.value.trim()) caixa.innerHTML = sugestoes();
    /* rAF: o campo precisa estar visível para o foco pegar no iOS. */
    requestAnimationFrame(function () {
      painel.classList.add('is-open');
      input.focus();
    });
  }

  function fecharPainel() {
    painel.classList.remove('is-open');
    painel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { painel.classList.add('hidden'); }, 200);
    abrir.focus();
  }

  abrir.addEventListener('click', function (e) { e.preventDefault(); abrirPainel(); });
  input.addEventListener('input', aoDigitar);

  limpar.addEventListener('click', function () {
    input.value = '';
    aoDigitar();
    input.focus();
  });

  painel.querySelector('[data-search-close]').addEventListener('click', fecharPainel);
  painel.querySelector('[data-search-backdrop]').addEventListener('click', fecharPainel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !painel.classList.contains('hidden')) fecharPainel();
  });

  caixa.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-search-term]');
    if (!chip) return;
    input.value = chip.getAttribute('data-search-term');
    aoDigitar();
    input.focus();
  });

  /* Enter envia o form e vai para a lista completa — comportamento esperado. */
  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });
})();